module.exports = new __parcel__URL__("arrow-left-disabled.e64b3d04.svg").toString();